import { useState, useEffect } from "react";
import { Modal, Select } from "@mantine/core";
import { withTranslation } from "react-i18next";
import InputField from "../../../components/inputField";
import Button from "../../../components/Button";
import { backendUrl } from "../../../constants";
import { DatePicker } from "@mantine/dates";
import { useForm } from "@mantine/form";
import { showNotification } from "@mantine/notifications";
import moment from "moment/moment";

const NewLocation = ({
  opened,
  setOpened,
  setRefetch,
  editId,
  setEditId,
  editEmployment,
  isEdit,
  setIsEdit,
}) => {
  let createdBy = JSON.parse(localStorage.getItem("userData"));
  const [privacyLevels, setPrivacyLevels] = useState([]);
  const [employeer, setEmployeer] = useState([]);

  //Edit Data
  useEffect(() => {
    if (editId && editEmployment) {
      form.setFieldValue("employeer", editEmployment?.employeer?._id);
      form.setFieldValue("jobTitle", editEmployment?.jobTitle);
      form.setFieldValue("privacyLevel", editEmployment?.privacyLevel?._id);
      form.setFieldValue("location", editEmployment?.location);
      form.setFieldValue("startDate", new Date(editEmployment?.startDate));
      form.setFieldValue("endDate", new Date(editEmployment?.endDate));
      form.setFieldValue("positionDuties", editEmployment?.positionDuties);
      form.setFieldValue("supervisor", editEmployment?.supervisor);
      form.setFieldValue("phoneNo", editEmployment?.phoneNo);
    } else {
      form.reset();
    }
  }, [editId, editEmployment]);

  //privacy Levels
  useEffect(() => {
    const options = {
      method: "GET",
    };

    fetch(`${backendUrl}lookup/getLookupByType/privacyLevel`, options)
      .then((response) => response.json())
      .then((response) => {
        response.data.map((obj) => {
          let a = { value: obj._id, label: obj.lookupName };
          setPrivacyLevels((p) => [...p, a]);
        });
      })
      .catch((err) => console.error(err));
  }, []);

  //Employeer
  useEffect(() => {
    const options = {
      method: "POST",
    };

    fetch(`${backendUrl}user/searchCompanies`, options)
      .then((response) => response.json())
      .then((response) => {
        console.log("res", response);
        response.data.map((obj) => {
          let a = { value: obj._id, label: obj.companyName };
          setEmployeer((p) => [...p, a]);
        });
      })
      .catch((err) => console.error(err));
  }, []);

  const handleClose = () => {
    setOpened(false);
    setEditId("");
    setIsEdit(false);
    form.reset();
  };

  const handleAddEmployement = async (values) => {
    values.userId = createdBy.id;
    if (editId) {
      values.employmentId = editId;
      const options = {
        method: "POST",
        headers: {
          Accept: "application/json",
          "content-type": "application/json",
        },
        body: JSON.stringify(values),
      };
      await fetch(`${backendUrl}user/editJobSeekerEmployment`, options)
        .then((response) => response.json())
        .then((response) => {
          showNotification({
            message: "Updated Successfully",
            color: "green",
          });
          setOpened(false);
          setRefetch((v) => !v);
        })
        .catch((err) => console.error(err));
    } else {
      values.userId = createdBy.id;
      const options = {
        method: "POST",
        headers: {
          Accept: "application/json",
          "content-type": "application/json",
        },
        body: JSON.stringify(values),
      };
      fetch(`${backendUrl}user/saveJobSeekerEmployment`, options)
        .then((response) => response.json())
        .then((response) => {
          setOpened(false);
          setRefetch((v) => !v);
        })
        .catch((err) => console.error(err));
    }
    form.reset();
  };

  // console.log("employeer",employeer)
  const form = useForm({
    validateInputOnChange: true,
    initialValues: {
      privacyLevel: "",
      employeer: "",
      location: "",
      jobTitle: "",
      startDate: "",
      endDate: "",
      positionDuties: "",
      supervisor: "",
      phoneNo: "",
    },

    validate: {
      privacyLevel: (value) =>
        value?.length < 1 ? "Please Select Privacy" : null,
      state: (value) => (value?.length < 1 ? "Please Select State" : null),
      employeer: (value) =>
        value?.length < 1 ? "Please Select Employeer" : null,
      location: (value) =>
        value?.length < 1 ? "Please Enter Job location" : null,
      jobTitle: (value) =>
        value?.length < 1 ? "Please Enter Job Title" : null,
      startDate: (value) =>
        value?.length < 1 ? "Please Select Start Date" : null,
      endDate: (value) => (value?.length < 1 ? "Please Select End Date" : null),
    },
  });
  return (
    <>
      <Modal
        styles={{
          title: {
            width: "100%",
            textAlign: "center",
            paddingLeft: "10px",
          },
        }}
        opened={opened}
        centered
        onClose={handleClose}
        title="Add New Employment"
      >
        <form
          onSubmit={form.onSubmit((values) => handleAddEmployement(values))}
        >
          <div style={{ marginLeft: "auto" }} className="col-md-4">
            <p style={{ margin: "0px", fontWeight: "500" }}>Privacy</p>
            <Select
              placeholder="Privacy Level"
              data={privacyLevels}
              searchable
              {...form.getInputProps("privacyLevel")}
            />
          </div>
          <Select
            label="Employer"
            placeholder="Select..."
            data={employeer}
            creatable
            maxDropdownHeight={400}
            {...form.getInputProps("employeer")}
          />
          <p style={{ margin: "0px", fontWeight: "500" }}>Location</p>
          <InputField
            placeholder={"City, State, or Zip Code"}
            style={{ border: "1px solid rgb(0,0,0,0.1)" }}
            validateName="location"
            form={form}
          />
          <hr />
          <p style={{ margin: "0px", fontWeight: "500" }}>Job Title</p>
          <InputField
            placeholder={"Job Title"}
            style={{ border: "1px solid rgb(0,0,0,0.1)" }}
            type={"text"}
            validateName="jobTitle"
            form={form}
          />
          <div className="row d-flex">
            <DatePicker
              placeholder="Start Date"
              label="Start Date"
              maxDate={new Date()}
              className="col-md-6"
              onInput={
                form.values.endDate < form.values.startDate &&
                form.setFieldValue("endDate", form.values.startDate)
              }
              {...form.getInputProps("startDate")}
            />
            <DatePicker
              label="End Date"
              disabled={form.values.startDate === ""}
              placeholder="End Date"
              className="col-md-6"
              maxDate={new Date()}
              minDate={new Date(form.values.startDate)}
              {...form.getInputProps("endDate")}
            />
          </div>
          <p style={{ margin: "0px", fontWeight: "500" }}>Position Duties</p>
          <textarea
            placeholder="Position Duties"
            rows={3}
            style={{
              border: "1px solid rgb(0,0,0,0.1)",
              borderRadius: "10px",
              padding: "5px",
              outline: "none",
              width: "25rem",
            }}
            {...form.getInputProps("positionDuties")}
          />
          <hr />
          <h6 className="text-dark text-bold">
            Optional Reference Information
          </h6>
          <div className="row d-flex">
            <div className="col-md-6">
              <InputField
                placeholder={"Supervisor"}
                style={{ border: "1px solid rgb(0,0,0,0.1)" }}
                {...form.getInputProps("supervisor")}
              />
            </div>
            <div className="col-md-6">
              <InputField
                placeholder={"Phone Number"}
                style={{ border: "1px solid rgb(0,0,0,0.1)" }}
                {...form.getInputProps("phoneNo")}
              />
            </div>
            <div
              className="d-flex justify-content-end gap-2"
              style={{ marginTop: "10px" }}
            >
              <Button title="Cancel" onClick={handleClose} />
              <Button
                title={editId ? "Edit Employment" : "Add Employement"}
                primary={true}
                type="submit"
              />
            </div>
          </div>
        </form>
      </Modal>
    </>
  );
};
export default withTranslation()(NewLocation);
